import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-user-terms-ohio',
  templateUrl: './user-terms-ohio.component.html',
  styleUrls: ['./user-terms-ohio.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserTermsOhioComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
